//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions } from 'vuex';

export default {
  name: 'ArticleList',
  data() {
    return {
      carouselItems: [],
    };
  },
  methods: {
    ...mapActions('article', ['setCategory', 'setCurrentId']),
    getArticles() {
      this.$api('getRandomArticle', { number: 9 }).then(data => {
        this.carouselItems = data;
      });
    },
    gotoArticle(value, id) {
      this.setCategory(value);
      this.setCurrentId(id || 0);
      this.$router.push(`/ArticleContent/${id}`);
    },
  },
  mounted() {
    this.getArticles();
  },
};
